<div class="flex flex-col flex-auto w-full max-w-6xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4">
        <h2 id="documents-heading">
            {{ 'label_pension_increases' | translate }}
        </h2>
        <p>
            {{ 'info_overview_and_invoices_for_pension_increases' | translate }}
        </p>
    </div>
    <div id="header" class="flex flex-col sm:flex-row md:flex-row py-6 px-0 !pt-1 mb-2 border-b mt-4">
        <form [formGroup]="form" #profileInNgForm="ngForm" class="flex flex-col sm:flex-row flex-wrap items-center w-full">
            <!-- Start Date Field -->
            <div class="flex flex-col sm:flex-row items-start flex-auto w-full sm:w-auto mt-4 sm:mt-0 sm:mr-4">
                <mat-form-field class="w-full">
                    <span class="mr-[18px]" matPrefix>{{ 'label_from' | translate }}</span>
                    <input
                        class="date"
                        formControlName="startDate"
                        matInput
                        placeholder="{{ 'text_date_from' | translate }}"
                        (click)="startDate.open()"
                        [matDatepicker]="startDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                    @if (this.form?.get('startDate')?.hasError('required')) {
                        <mat-error>
                            {{ 'info_date_required' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
            <!-- End Date Field -->
            <div class="flex flex-col sm:flex-row items-start flex-auto w-full sm:w-auto mt-4 sm:mt-0 sm:mr-4">
                <mat-form-field class="w-full">
                    <span class="mr-[18px]" matPrefix>{{ 'label_to' | translate }}</span>
                    <input
                        class="date"
                        formControlName="endDate"
                        matInput
                        placeholder="{{ 'text_date_to' | translate }}"
                        (click)="endDate.open()"
                        [matDatepicker]="endDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                    @if (this.form?.get('endDate')?.hasError('required')) {
                        <mat-error>
                            {{ 'info_date_required' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
            <!-- Submit Button -->
            <div class="flex items-start flex-auto w-full sm:w-auto mt-4 sm:mt-0">
                <button
                    class="ml-0 sm:ml-4 min-w-[120px] w-full sm:w-auto"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="listPensionIncreaseClaims()"
                >
                    <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <span class="ml-2 mr-1 block">{{ 'label_fetch_records' | translate }}</span>
                </button>
            </div>
        </form>
    </div>
    <ng-container>
        <div>
            @if (pensionIncreaseClaims?.length > 0) {
                <div class="mt-1.5 justify-center overflow-x-auto">
                    <!-- Filter Input and Toggle -->
                    <div class="flex flex-col sm:flex-row sm:items-center w-full mt-2">
                        <!-- Text Input for Filter -->
                        <mat-form-field class="w-full sm:w-full sm:mr-4 mb-4 sm:mb-0">
                            <input
                                matInput
                                placeholder="{{ 'text_filter_by_text' | translate }}"
                                [(ngModel)]="filterText"
                                (ngModelChange)="applyFilter()"
                                autocomplete="off"
                            />
                        </mat-form-field>
                        <!-- Toggle for DocumentId -->
                        <mat-checkbox class="w-full sm:w-auto mb-4" [(ngModel)]="showOnlyWithDocumentId" (change)="applyFilter()">{{
                            'label_show_only_records_without_invoice' | translate
                        }}</mat-checkbox>
                    </div>
                    <table mat-table matSort [dataSource]="dataSource" class="w-full table-expandable">
                        <ng-container matColumnDef="ssn">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_ssn' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ formatSsn(element.ssn) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_name' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.name }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="claimId">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_claim_id' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.claimId }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="totalPensionIncrease">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_total_pension_increase' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.totalPensionIncrease | translocoDecimal }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="billCharge">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_bill_charge' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.billCharge | translocoDecimal }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="pensionScheduleDate">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_paid' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.pensionScheduleDate | date: 'dd.MM.yyyy' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="scheduleNumber">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_schedule' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.scheduleNumber }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="receiptNumber">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_receipt' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.receiptNumber }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actionNumber">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_action' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.actionNumber }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="recordedDate">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_recorded' | translate }}
                            </th>
                            <td
                                mat-cell
                                (click)="documentPensionIncreaseClaims(element)"
                                (click)="getDocument(element)"
                                *matCellDef="let element"
                            >
                                {{ element.recordedDate | date: 'dd.MM.yyyy' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="recordedBy">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ 'label_user' | translate }}
                            </th>
                            <td mat-cell (click)="documentPensionIncreaseClaims(element)" *matCellDef="let element">
                                {{ element.recordedBy }}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr
                            [class.bg-green-100]="docrow.documentId != null"
                            class="hover:opacity-70 hover:cursor-pointer"
                            mat-row
                            *matRowDef="let docrow; columns: tableColumns"
                        ></tr>
                    </table>
                </div>
            }
            <mat-paginator
                #paginator
                [length]="dataSource?.data?.length"
                [pageSizeOptions]="pageSizes"
                showFirstLastButtons
                [ngClass]="{
                    hidden: pensionIncreaseClaims?.length === 0,
                    block: pensionIncreaseClaims?.length > 0,
                }"
            >
            </mat-paginator>
        </div>
        @if (pensionIncreaseClaims?.length == 0 && !isLoading) {
            <div class="flex flex-col flex-auto items-center justify-center h-full p-6 sm:p-10">
                <div class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
                    {{ 'info_pension_increase_claims_found_count' | translate: { count: 0 } }}
                </div>
                <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">
                    {{ 'info_pension_increase_claims_filter' | translate }}
                </div>
            </div>
        }
    </ng-container>
    @if (this.dataSource.filteredData.length > 0) {
        <div class="flex flex-col items-end w-full mt-4">
            <button
                class="min-w-[120px] w-full sm:w-auto"
                mat-flat-button
                [color]="'primary'"
                (click)="createInvoicesPensionIncreaseClaims()"
            >
                <span class="block text-base">{{ 'label_send_invoices' | translate }}</span>
            </button>
            <p class="text-sm mt-2 text-right">
                {{ 'info_invoices_creation_notice' | translate }}
            </p>
        </div>
    }
</div>
